export default "__VITE_ASSET__vJSi2sKF__"